<script>
import { zendeskActions } from '@state/helpers'
import { mapState } from 'vuex'
import zendesk from '@/mixins/zendesk-utils.js'
import PhoneNumberItem from '@components/phone-number-item'
import SubHeader from '@components/sub-header'
import CustomArrow from '@components/custom-arrow'

export default {
  name: 'CallRestaurant',
  components: {
    PhoneNumberItem,
    SubHeader,
    CustomArrow,
  },
  mixins: [zendesk()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      phoneNumbers: '',
    }
  },
  computed: {
    ...mapState('widgets', {
      orderData: state => state.data.SharedData.orderData,
    }),
  },
  watch: {},
  created () {
    this.phoneNumbers = this.componentData.phone
      ? this.componentData.phone.split(';')
      : []
  },
  methods: {
    ...zendeskActions,
    onPhoneNumberUpdate: function (phoneNumber) {
      phoneNumber = JSON.parse(JSON.stringify(phoneNumber))
    },
  },
}
</script>

<template>
  <div :class="$style.container">

    <div :class="$style.container__content">
      <PhoneNumberItem
        v-for="(phoneNumber,i) in phoneNumbers"
        :key="i"
        :phone-number="phoneNumber"
        @phoneNumberUpdate="onPhoneNumberUpdate"
      />
      <SubHeader
        :text="`${$t('WIDGETS.CALL_RESTAURANT.YOUR_ORDER_ID')}: ${orderData.id}`"
        :class="$style.container__subheader"
      />
    </div>

  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  background-color: transparent;

  &__content {
    margin: 1rem;
    padding: 1rem;
    background-color: $background-container;

    border-radius: 22px;
    overflow: hidden;
    box-shadow: $regular-box-shadow;
  }

  &__subheader {
    @extend %typography-medium;

    margin: 1rem 0.3rem;

    font-size: 1.1rem;
    font-weight: 600;

    color: $orange-primary;
  }

  &__simple {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  &__header {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

    &Title {
      @extend %typography-large;

      max-width: 66%;
      margin: 0 0 0 0.3rem;
      overflow: hidden;
      color: $charcoal-gray;
      text-overflow: ellipsis;
    }

    img {
      max-width: 3rem;
      max-height: 3rem;
      vertical-align: middle;
    }
  }
}
</style>
